/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 10/10/2023
 */


import React from 'react';
import { Button, Grid,  TextField, Typography, styled } from '@mui/material';
import Styles from "./ContactForm.module.css";
import { Send } from '@mui/icons-material';
import { useState } from 'react';
import { useCreateMessageMutation } from '../../services/issueService';
import CircularProgress from '@mui/material/CircularProgress';
import Success from './Success';

const FormField = styled(TextField)({
    '& label.Mui-focused': {
      color: '#5fa9e0',
      fontSize: '1.25rem'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#5fa9e0',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#5fa9e0',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#5fa9e0',
      },
      '&:hover fieldset': {
        borderColor: '#5fa9e0',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#5fa9e0',
      },
    },
    '& .MuiInputLabel-root': {
        color: '#5fa9e0'
    }
});

const ContactForm = () => {

  const [data, setData] = useState({})
  const [open, setOpen] = useState(false)
  const [send, setClickSend] = useState(false)

  const [createMessage] = useCreateMessageMutation();

  const handleSubmit = async (e) => {
    setClickSend(true);
    e.preventDefault();
    
    try {
      const respond = await createMessage(data).unwrap();
      setOpen(true);
      setClickSend(false);
    } catch (err) {
        console.error("Failed to save the Message: ", err);
    }
  }

    return (
      <div>
        <div className={Styles.outerContainer}>
            <Grid container>
                <Grid item xs={12} md={11} className={Styles.textContainer}>
                <div className={Styles.formContainer}>
                    <Typography className={Styles.formHeading}>
                        Let&apos;s discuss on something cool together
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <FormField onChange={e => setData({...data, requesterName: e.target.value})} className={Styles.formInput} fullWidth label="Your name" variant="standard" required />
                        <FormField onChange={e => setData({...data, email: e.target.value})} className={Styles.formInput} fullWidth label="Your email" variant="standard" required />
                        <FormField onChange={e => setData({...data, mobileNumber: e.target.value})} className={Styles.formInput} fullWidth label="Your mobile number" type='number' variant="standard" required />
                        <FormField onChange={e => setData({...data, message: e.target.value})} className={Styles.formInput} fullWidth label="Your message" variant="standard" required />
                        
                        <Button type='submit' variant='contained' className={Styles.button}>{send==true ? <CircularProgress className={Styles.bottonIcon} /> : <Send className={Styles.bottonIcon} />  }   Send </Button>
                    </form>
                </div>
                </Grid>
            </Grid>
        </div>
        <Success 
          open={open} 
          onClose={() => {
            setOpen(false)
            window.location.reload()
          }}
          props={data.requesterName}
        />
      </div>
    )
}
 
export default ContactForm